<template>
  <div
    class="c-input"
    style="width: 300px;"
  >
    <div class="c-input__title" :class="{'u-w190': isHorizontal}">{{ title }}</div>
    <div class="c-input__text">{{ description }}</div>
    <input
      v-model="dataValue"
      :name="inputName"
      class="c-input__item text_input"
      type="text"
      :placeholder="placeholder"
    />
    <input
      v-model="dataValue"
      :name="inputName"
      class="c-input__item color_input"
      type="color"
      :placeholder="placeholder"
    />
    <div class="c-error c-error--balloon" :class="{'is-active': errorMessage !== '' }">
      <div class="c-error__text">{{ errorMessage }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    inputName: String,
    title: String,
    description: String,
    data: [String, Number],
    placeholder: String,
    errorMessage: {
      type: String,
      default: ''
    },
    isHorizontal: {
      type: Boolean,
      default: false
    }
  },
  emits: ["value-changed"],
  data() {
    return {
      dataValue: this.data
    }
  },
  updated: function () {
    const self = this;
    this.$nextTick(function () {
      this.$emit("value-changed", self.dataValue);
    });
  },
  methods: {
    changeValue: function(value) {
      this.dataValue = value;
    }
  }
}
  </script>

<style>
.text_input {
    width: 140px;
    margin-right: 10px;
}
.color_input {
    margin: 0;
    padding: 0;
    width: 48px;
    height: 48px;
}
</style>